import React from "react";
import { AiOutlineAlert } from "react-icons/ai";

export default function OffSiteReordersMenuItem(name: string) {
    return [
        <AiOutlineAlert key={`${name}-icon`} size={"1.5em"} />,
        <div key={`${name}-text`}>
            <span>{name}</span>
        </div>,
    ];
}
